import { jsx } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmVolume, IconLlmVolumeX } from '@websolutespa/bom-mixer-icons';
import { useLlm } from '../../../useLlm/useLlm.js';
import style from './page-synthesis.module.scss.js';

const PageSynthesis = () => {
  const label = useLabel();
  const speakEnabled = useLlm(state => state.speakEnabled);
  const {
    toggleSpeak,
    hasSpeechSynthesisSupport
  } = useLlm(state => state.actions);
  const hasSpeechSynthesis = hasSpeechSynthesisSupport();
  return hasSpeechSynthesis && jsx("button", {
    type: "button",
    className: getClassNames(style.synthesis),
    "aria-label": speakEnabled ? label('llm.disableSpeak') : label('llm.enableSpeak'),
    "aria-pressed": speakEnabled,
    onClick: toggleSpeak,
    children: speakEnabled ? jsx(IconLlmVolume, {}) : jsx(IconLlmVolumeX, {})
  });
};

export { PageSynthesis };
//# sourceMappingURL=page-synthesis.js.map
